/** @format */

export const TOGGLE_THEME = "CHANGE_THEME";
export const TOGGLE_SEARCH = "TOGGLE_SEARCH";
export const TOGGLE_GENRE = "TOGGLE_GENRE";



//for app data variables
export const SET_APP_DATA = "SET_APP_DATA";
export const SET_ANIME_LIST = "SET_ANIME_LIST";
export const UPDATE_ANIME_LIST = "UPDATE_ANIME_LIST";
export const SET_NEWS = "SET_NEWS";
export const UPDATE_NEWS = "UPDATE_NEWS";
export const SET_ANIME_DETAILS = "SET_ANIME_DETAILS";
export const SET_GENRE = "SET_GENRE";
export const SET_LATEST_ANIME = "SET_LATEST_ANIME";
export const SET_STUDIO_LIST = "SET_STUDIO_LIST";
export const SET_TRENDING_NOW = "SET_TRENDING_NOW";
export const SET_RECENTLY_ADDED = "SET_RECENTLY_ADDED";
export const SET_RECOMMENDED_LIST = "SET_RECOMMENDED_LIST";
export const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";
export const ADD_BOOKMARK = "ADD_BOOKMARK";
export const SET_IS_LOADED = "SET_IS_LOADED";
export const SET_SEARCH_STATUS = "SET_SEARCH_STATUS";
export const SET_MOVIES = "SET_MOVIES";